module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (187).fc36184f.jpg";